<template>

  <div :class="['cookie-disclaimer', cookiesAccepted ? '' : 'show']">
    <div class="disc-inner">
      <div class="desc" v-html="localeText[locale.ln]">
        <!-- <span v-text="localize('cookies_disclaimer')"></span> -->
      </div>
    </div>
    <button
      @click="acceptCookies"
      class="btn-accept"
      v-text="localize('accept')"
    ></button>
  </div>

  <!--
  <div :class="['cookie-disclaimer', cookiesAccepted ? '' : 'show']">
    <div class="disc-inner">
      <h4 v-text="title"></h4>
      <div class="desc" v-html="localeText[locale.ln]">
      </div>
    </div>
    <button
      @click="acceptCookies"
      class="btn-accept"
      v-text="localize('accept')"
    ></button>
  </div> 
  -->


</template>
<script>
import { mapState } from "vuex";
export default {
  name: "cookies-disclaimer",
  props: {
    triggerAccept: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: "MIS_GLOBAL_accepted_cookies",
      accepted: false,
      localeText: {
        en:
          'This website stores cookies on your computer. These cookies are used to improve our website and to provide you with personalized services both on the website and through other media. If you have any questions about cookies and would like more information, please refer to our <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">Cookies Policy</a>.',
        fr: `Ce site web stocke des cookies sur votre ‎ordinateur. Ces cookies sont utilisés pour ‎améliorer notre site Web et vous fournir des ‎services personnalisés à la fois sur le site Web et ‎par l’intermédiaire d’autres médias. Si vous avez ‎des questions sur les cookies et que vous ‎souhaitez obtenir plus d’informations, veuillez ‎vous référer à notre <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">politique de cookies</a>.`,
        tr: `Bu Sitede, kullanıcı deneyimini geliştirmek ve internet sitesinin verimli çalışmasını sağlamak amacıyla çerezler kullanılmaktadır. Bu konudaki sorularınız ve daha fazla bilgi için lütfen Çerez <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">Politikası bölümüne</a> bakınız.`,
        de: `Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies werden verwendet, um unsere Website zu verbessern und Ihnen personalisierte Dienste sowohl auf der Website als auch über andere Medien zur Verfügung zu stellen. Wenn Sie Fragen zu Cookies haben und weitere Informationen wünschen, wenden Sie sich bitte an die <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">Cookie-Richtlinien</a>.`,
        es: `Este sitio web almacena cookies en su servidor. Estas cookies se utilizan para mejorar nuestro sitio web y proporcionarle servicios personalizados tanto en la web como a través de otros medios. Si tiene alguna pregunta sobre las cookies y desea obtener más información, consulte nuestra <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">Política de cookies</a>.`,
        it: `Questo sito Web memorizza i cookie sul tuo computer. Questi cookie vengono utilizzati per migliorare il nostro sito Web e per fornire servizi personalizzati sia sul sito Web che tramite altri media. Se hai domande sui cookie e desideri maggiori informazioni, consulta la nostra <a target="_blank" href="https://www.mis-implants.com/Privacy-Policy?cookies">Politica sui cookie</a>.`
      }
    };
  },
  watch: {
    triggerAccept() {
      if (this.triggerAccept) {
        this.acceptCookies();
      }
    }
  },
  computed: {
    ...mapState(["locale"]),
    storageSupport() {
      try {
        return "localStorage" in window && window["localStorage"] !== null;
      } catch (e) {
        return false;
      }
    },
    title() {
      return this.localize("mis_cookies");
    },
    cookiesAccepted() {
      return this.getFromStorage(localStorage, this.key) || this.accepted;
    },
    isMobile() {
      let w = window.innerWidth,
        h = window.innerHeight;
      return (w > h && w < 813) || (h > w && h < 813);
    },
    isPortrait() {
      return window.innerHeight >= window.innerWidth;
    }
  },
  methods: {
    acceptCookies() {
      if (this.storageSupport) {
        this.setToStorage(localStorage, this.key, true);
        this.accepted = true;
      }
    },
    /*
			// SAVE TO STORAGE
			@ storageType -- sessionStorage || localStorage
			@ key
			@ data -- value
			@daysToExpire    -- default is 3
		*/
    setToStorage(storageType, key, data, daysToExpire) {
      daysToExpire = daysToExpire || 30;
      if (this.storageSupport) {
        storageType.setItem(key, data);
        if (storageType === sessionStorage && !!daysToExpire) {
          this.setStorageExpiration(storageType, key, daysToExpire);
        }
      }
      // else {
      // 	Cookies.set('name', 'value', { expires: daysToExpire || null });
      // }
    },
    /*
			// FETCH FROM STORAGE
			@ storageType -- sessionStorage || localStorage
			@ key

		*/
    getFromStorage(storageType, key) {
      if (this.storageSupport) {
        if (storageType === sessionStorage) {
          this.checkStorageExpiration(storageType, key);
        }
        return storageType.getItem(key) || null;
      }
      // else {
      // 	return Cookies.get(key) || null

      // }
      return null;
    },

    // CHECK EXPIRATION
    checkStorageExpiration(storageType, key) {
      let curdate = new Date(),
        date = new Date(storageType.getItem(key + "_expiration"));
      if (!!date && curdate > date) {
        this.removeFromStorage(storageType, key);
      }
    },
    // SET EXPIRATION
    setStorageExpiration(storageType, key, days) {
      let expiredate = new Date();
      expiredate.setDate(expiredate.getDate() + days);
      storageType.setItem(key + "_expiration", expiredate);
    },

    // REMOVE FROM STORAGE
    removeFromStorage(storageType, key) {
      if (this.storageSupport && !!storageType) {
        storageType.removeItem(key);
        storageType.removeItem(key + "_expiration");
      } else {
        // Cookies.remove(key);
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.cookie-disclaimer
	border-top 2px solid c_md_blue
	position fixed
	bottom 0
	width 100%
	background c_dk_blue
	min-height 130px
	transform translateY(100%)
	opacity 0
	z-index 10000006
	transition transform 0.35s ease-out, opacity 1s ease-out
	&.show
		opacity 1
		transform translateY(0)
	.disc-inner
		width 60vw
		height 65%
		position absolute
		top 50%
		left 4%
		transform translateY(-50%)
		+below(1200px)
			width 75vw
		+below(1025px, orientation: portrait)
			position relative
			width 100%
			height 100%
			top 0
			left 0
			transform none
	.desc
		overflow auto
		color #fff
		padding 10px 20px
		//border-left 1px solid rgba(#fff, 0.5)
		font-size responsive 12px 16px
		+below(769px)
			padding-right 7%
		+below(1025px, orientation: portrait)
			padding 3vmin
			border 0
		& >>> a,
		& >>> a:visited
			// font-size 1.5vmin
			display inline
			text-decoration underline
			color #0075be !important

.cookie-disclaimer
  +below(800px,orientation: portrait)
    min-height 50px

	h4
		float left
		font-size responsive 24px 32px
		color #fff
		margin 0
		padding 10px 20px
		font-weight normal
		+below(1750px)
			font-size 30px
		+below(769px)
			padding-top 20px
		+below(1025px, orientation: portrait)
			float none
			font-size 28px
			margin 0 auto
			padding 20px
			width 60%
			color #fff
			border-bottom 1px solid #333333
			font-weight normal
			text-align center

	.btn-accept
		background #36bae9
		border-radius 5px
		color #fff
		text-align center
		border 0
		padding 10px 20px
		position absolute
		top 50%
		left 64vw
		transform translateY(-50%)
		cursor pointer
		transition background 0.25s
		+below(1200px)
			left 80vw
		+below(1025px, orientation: portrait)
			position static
			border-radius 3px
			padding 10px 20px
			display block
			margin 20px auto 0px
		&:hover
			background #32acd8
</style>
